import { createSvgIcon } from '@ori-ui/mui-bundle/material/utils';
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon(/*#__PURE__*/_jsx("path", {
  d: "M5 12a.5.5 0 0 1 .5-.5h13a.5.5 0 0 1 0 1h-13A.5.5 0 0 1 5 12"
}), 'Remove');
//# sourceMappingURL=index.js.map